module.exports = __webpack_public_path__ + "static/media/foto_1.4471e507.png";